import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Checkbox.module.scss";
const Checkbox = (props) => {
  const { type, id, value, section, inputCallback, checkedStatus } = props;
  const [isChecked, setChecked] = useState(checkedStatus);
  const refInput = useRef(null);
  let wrapClass = `${styles.wrap}`
  // useEffect(()=>{
  //   if(isChecked){
  //     inputCallback(section, id);
  //   }else{
  //     inputCallback(section, id);
  //   }
  // },[id, inputCallback, isChecked, section]);
  useEffect(()=>{
    refInput.current.checked = checkedStatus;
  },[checkedStatus, value]);
  if (type !== undefined && styles[`wrap_${type}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${type}`]}`;
  }
  return (
    <>
      <label htmlFor={`input-${section}-${id}`} className={wrapClass}>
        <input type={type === 'radio' ? 'radio' : 'checkbox'} id={`input-${section}-${id}`} className={styles.input} name={section} onChange={()=>{inputCallback(section, id)}} ref={refInput}/>
        <div className={styles.icon}>
          {
            type === 'radio' ? <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="4" fill="#008359"/>
            </svg>
             :
              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.1288 7.89042L1.04606 4.78196L0 5.83675L4.1288 10L13 1.05479L11.9539 0L4.1288 7.89042Z" fill="#008359" />
              </svg>
          }
        </div>
        <div className={styles.name}>{value}</div>
      </label>
    </>
  );

}

export default Checkbox;
